module.exports = __webpack_public_path__ + "media/images/curriculum_pikkachan_smile-f1209f8a1fa2960f78312014ac1c3bc1.png";